export const services = {
  pt: {
    servicesTitle: {
      first: "Nossos",
      second: "Serviços",
      description: "Oferecemos soluções completas para dar vida ao seu projeto de jogo"
    },
    services: [
      {
        id: 1,
        title: "Programação Unity",
        description: "Desenvolvimento completo em C# utilizando Unity. Implementação de gameplay, UI, IA, experiências em VR/XR e otimização de performance."
      },
      {
        id: 2,
        title: "Art 2D e 3D",
        description: "Criação de concept art, sprites, animações e interfaces visuais com qualidade profissional."
      },
      {
        id: 3,
        title: "Modelagem 3D",
        description: "Modelagem de personagens, cenários e objetos 3D com texturização, rigging e preparação para uso em jogos."
      },
      {
        id: 4,
        title: "Game Design",
        description: "Planejamento do jogo, documentação, balanceamento de mecânicas e construção da narrativa."
      },
      {
        id: 5,
        title: "Desenvolvimento Completo",
        description: "Do conceito ao lançamento, gerenciando todo o processo de desenvolvimento."
      },
      {
        id: 6,
        title: "Terceirização",
        description: "Suporte profissional para reforçar sua equipe."
      }
    ]
  },

  en: {
    servicesTitle: {
      first: "Our",
      second: "Services",
      description: "We offer complete solutions to bring your game project to life"
    },
    services: [
      {
        id: 1,
        title: "Unity Programming",
        description: "Full development in C# using Unity. Implementation of gameplay, UI, AI, VR/XR experiences and performance optimization."
      },
      {
        id: 2,
        title: "2D and 3D Art",
        description: "Creation of concept art, sprites, animations and visual interfaces with professional quality."
      },
      {
        id: 3,
        title: "3D Modeling",
        description: "Modeling of characters, environments and objects with texturing, rigging and game-ready setup."
      },
      {
        id: 4,
        title: "Game Design",
        description: "Game planning, documentation, mechanics balancing and narrative design."
      },
      {
        id: 5,
        title: "Full Development",
        description: "From concept to launch, managing the entire development process."
      },
      {
        id: 6,
        title: "Outsourcing",
        description: "Professional support to strengthen your team."
      },
    ]
  }
}